import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterStatusService {
  private filtersAppliedSubject = new BehaviorSubject<boolean>(false);
  private filterCountSubject = new BehaviorSubject<number>(0);

  filtersApplied$ = this.filtersAppliedSubject.asObservable();
  filterCount$ = this.filterCountSubject.asObservable();

  constructor() {}

  setFiltersApplied(applied: boolean, count: number = 0): void {
    this.filtersAppliedSubject.next(applied);
    this.filterCountSubject.next(count);
  }

  getFiltersApplied(): boolean {
    return this.filtersAppliedSubject.value;
  }

  getFilterCount(): number {
    return this.filterCountSubject.value;
  }
}